import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Div, Divider, Media, Rating, Text } from '@pezeshk-book/ui-kit';
import Image from '@elements/image';
import { DoctorItemProps } from '../doctors.props';
import { DoctorAccordionDetails } from '../sub-component';
import Link from 'next/link';
import routes from '@routes';
import getParseRoute from '@utils/helpers/parse-route';
import DoctorItemButtons from '../sub-component/doctor-item-buttons';
import LocationOutlineIcon from '@icons-components/location-outline-icon';

const DoctorItem = ({ name, slug, provinceTitle, userServiceFee, hashUserId, userContacts, typeTitle, isOnline, specialityType, speciality, rate = 5, photo, locale = 'fa', translate }: DoctorItemProps) => {
  return (
    <Accordion className={'w-full bg-white !p-0'} rounded={'medium'} color={'tertiary'}>
      <AccordionSummary
        size={'large'}
        className={'flex-col !justify-start pb-4 sm:px-5 md:px-10 relative !h-auto shadow-lg'}
      >
        <Div className={'w-full flex-col'}>
          <Div className={'relative flex-col sm:flex-row w-full pt-3 md:px-8 justify-between'}>
            <Div className={'justify-between'}>
              <Div className={'gap-5 md:gap-10'}>
                <Div itemScope itemType="http://schema.org/Physician" className={'items-center flex-col gap-4'}>
                  <Link prefetch={true} passHref={true} href={getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug }, locale: locale })}>
                    <Div className={'w-24 h-24 relative border-2 border-control-100 rounded-full'}>
                      <Image itemProp={'image'} src={photo} className={'rounded-full object-contain'} alt={name}/>
                    </Div>
                  </Link>
                  <Rating value={Number(rate)} readOnly={true}/>
                </Div>
                <Link prefetch={true} passHref={true} href={getParseRoute({ pathname: routes['route.users.show'], query: { slug: slug }, locale: locale })}>
                  <Div className={'items-start flex-col md:mt-5 gap-1'}>
                    <Text align={'start'} color={'tertiary'} type={'bold'} typography={'base'}>{typeTitle} {name}</Text>
                    <Text itemProp="name" align={'start'} color={'grey.500'} type={'bold'} typography={'base'}>{specialityType}</Text>
                    <Text itemProp="description" align={'start'} color={'grey.500'} typography={'sm'}>{speciality}</Text>
                  </Div>
                </Link>
              </Div>
              <Media at={'xs'}>
                <Div className={'items-center mt-2 self-start gap-1'}>
                  <Div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-tertiary' : 'bg-danger'}`}/>
                  <Text color={'grey.600'} typography={'xs'}>{isOnline ? translate.online : translate.offline}</Text>
                </Div>
              </Media>
            </Div>
            <DoctorItemButtons slug={slug} hashUserId={hashUserId} userServiceFee={userServiceFee} />
          </Div>
          <Div className={'pt-3'}>
            <Divider color={'control'}/>
          </Div>
          <Div className={'w-full pr-2 md:pr-16 mt-3 items-center'}>
            <Media greaterThan={'xs'}>
              <Div className={'items-center gap-1'}>
                <Div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-tertiary' : 'bg-danger'}`}/>
                <Text color={'grey.600'} typography={'xs'}>{isOnline ? translate.online : translate.offline}</Text>
              </Div>
            </Media>
            <Div className={'items-center self-center mx-16 gap-x-1'}>
              <Div className={'relative justify-center items-center w-3 h-3 md:w-5 md:h-5'}>
                <LocationOutlineIcon/>
              </Div>
              <Text typography={'sm'}>
                {provinceTitle}
              </Text>
            </Div>
          </Div>
        </Div>
      </AccordionSummary>
      <AccordionDetails className={'rounded-b-2xl'}>
        <DoctorAccordionDetails translate={translate} userContacts={userContacts} />
      </AccordionDetails>
    </Accordion>
  );
};

export default DoctorItem;
